import React from 'react'
import { useCallback } from 'sb-hooks'

import useRecurly from './useRecurly'


type RecurlyFormProps = {
  onSubmit: () => void
}

const RecurlyForm: React.FunctionComponent<RecurlyFormProps> = ({ children, onSubmit }) => {
  const recurly = useRecurly()

  const handleSubmit = useCallback((event) => {
    event.preventDefault()
    onSubmit()
  }, [ onSubmit ])

  return (
    <form ref={recurly.formRef} noValidate onSubmit={handleSubmit}>
      {/* recurly requires country field (https://docs.recurly.com/docs/site-settings#section-taxes) */}
      {/* as @sonatskiy said this required on credit card update flow */}
      <input
        data-recurly="country"
        type="hidden"
        name="country"
        value="United States"
        readOnly
      />
      {children}
    </form>
  )
}


export default RecurlyForm
